import React from 'react'
import { connect } from 'react-redux'
import CouponProviderActions from '../../Redux/CouponProviderRedux'

class UpdateProvider extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      id: props.detail.id || '',
      form: {
        name: props.detail.name || ''
      }
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let form = {...this.state.form}
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.form}
    let id = this.state.id
    let data = {
      form,
      id
    }
    this.props.putCouponProvider(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h3 className='title'>Update Provider</h3>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Name</label>
            </div>
            <div className='col-9'>
              <input
                className='form-control'
                type='text'
                placeholder='Provider Name'
                value={this.state.form.name}
                onChange={(event) => this._inputChange(event, 'name')}
                required
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button className='btn btn-secondary mr-2' type='button' onClick={() => this.props.closeModal()}>Cancel</button>
              <button className='btn btn-primary' type='submit'>Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  putCouponProvider: (data) => dispatch(CouponProviderActions.putCouponProviderRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateProvider)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/UpdateProvider.js